import { createContext, useContext } from 'react';
export const TabsHeaderContext = createContext(false);
export const TabsListContext = createContext(false);
export const TabsActionsContext = createContext(false);
export function useIsInsideTabsHeader() {
    return useContext(TabsHeaderContext);
}
export function useIsInsideTabsList() {
    return useContext(TabsListContext);
}
export function useIsInsideTabsActions() {
    return useContext(TabsActionsContext);
}
//# sourceMappingURL=useTabsStructure.js.map